"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductBox = void 0;
var _react = _interopRequireDefault(require("react"));
var _ProductBoxList = require("./ProductBoxList");
var _ProductBoxTable = require("./ProductBoxTable");
var _ProductBoxTile = require("./ProductBoxTile");
var _ = require("./");
const ProductBox = _ref => {
  let {
    onCategoryClick,
    onProductClick,
    styleType,
    ...originalProps
  } = _ref;
  const handleProductClick = sku => e => {
    onProductClick(e, sku);
    e.preventDefault();
  };
  const handleCategoryClick = url => e => {
    onCategoryClick(url);
    e.preventDefault();
  };
  const props = {
    ...originalProps,
    onCategoryClick: handleCategoryClick,
    onProductClick: handleProductClick
  };
  switch (styleType) {
    case _.PRODUCT_BOX_STYLE_TYPE.list:
      return /*#__PURE__*/_react.default.createElement(_ProductBoxList.ProductBoxList, props);
    case _.PRODUCT_BOX_STYLE_TYPE.table:
      return /*#__PURE__*/_react.default.createElement(_ProductBoxTable.ProductBoxTable, props);
    case _.PRODUCT_BOX_STYLE_TYPE.tile:
    default:
      return /*#__PURE__*/_react.default.createElement(_ProductBoxTile.ProductBoxTile, props);
  }
};
exports.ProductBox = ProductBox;
//# sourceMappingURL=ProductBox.js.map